import React from "react";

const CenterVertAlign = ({ width = 14, height = 14, selected }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_355_945)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.5 8.5V9.5H0.5V8.5H14.5Z"
          fill={selected ? "white" : "black"}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.5 0.5V3.5H5.5V0.5H9.5Z"
          fill={selected ? "white" : "black"}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.5 4.5V7.5H5.5V4.5H9.5Z"
          fill={selected ? "white" : "black"}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.5 10.5V13.5H5.5V10.5H9.5Z"
          fill={selected ? "white" : "black"}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.5 14.5V17.5H5.5V14.5H9.5Z"
          fill={selected ? "white" : "black"}
        />
      </g>
      <defs>
        <clipPath id="clip0_355_945">
          <rect width="15" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CenterVertAlign;
